import { useCrisisImprovementActionsStore } from '../../store/crisis-improvement-actions.store.js';
import { BcmSourcedImprovementActionsIntegration } from './bcm-sourced-improvement-actions.integration.js';

export class CrisisImprovementActionsIntegration extends BcmSourcedImprovementActionsIntegration {
    constructor(actionService) {
        super(actionService, {
            sourceType: 'crisis-event',
            store: () => useCrisisImprovementActionsStore.getState(),
            messagesNs: 'bcmCrisisEvent',
        });
    }
}
